"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhDatePicker = void 0;
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var antd_1 = require("antd");
var DatePickerBase_1 = require("./DatePickerBase");
var object_1 = require("../utils/object");
var BaseRangePicker = antd_1.DatePicker.RangePicker;
var WhDatePicker = function (_a) {
    var onChange = _a.onChange, dropdownClassName = _a.dropdownClassName, props = __rest(_a, ["onChange", "dropdownClassName"]);
    var showTime = props.showTime;
    return (react_1.default.createElement(antd_1.DatePicker, __assign({}, object_1.object(!showTime && { format: "LL" }), props, DatePickerBase_1.getDatePickerBaseProps({ dropdownClassName: dropdownClassName }), { onChange: function (momentDate, dateString) {
            onChange === null || onChange === void 0 ? void 0 : onChange(momentDate, 
            // eslint-disable-next-line no-nested-ternary
            showTime
                ? dateString
                : momentDate
                    ? moment_1.default(momentDate).format("YYYY-MM-DD")
                    : "");
        } })));
};
exports.WhDatePicker = WhDatePicker;
var WhRangePicker = function (_a) {
    var onChange = _a.onChange, dropdownClassName = _a.dropdownClassName, props = __rest(_a, ["onChange", "dropdownClassName"]);
    var showTime = props.showTime;
    return (react_1.default.createElement(BaseRangePicker, __assign({}, object_1.object(!showTime && { format: "LL" }), props, DatePickerBase_1.getDatePickerBaseProps({ dropdownClassName: dropdownClassName }), { onChange: function (momentDate, dateString) {
            onChange === null || onChange === void 0 ? void 0 : onChange(momentDate, 
            // eslint-disable-next-line no-nested-ternary
            showTime
                ? dateString
                : momentDate
                    ? [
                        moment_1.default(momentDate === null || momentDate === void 0 ? void 0 : momentDate[0]).format("YYYY-MM-DD"),
                        moment_1.default(momentDate === null || momentDate === void 0 ? void 0 : momentDate[1]).format("YYYY-MM-DD"),
                    ]
                    : ["", ""]);
        } })));
};
WhDatePicker.RangePicker = WhRangePicker;
var DATE_PICKER_FORMAT = "LL";
var DATE_PICKER_FORMAT_TIME = "LLL";
WhDatePicker.FORMATS = { DATE_PICKER_FORMAT: DATE_PICKER_FORMAT, DATE_PICKER_FORMAT_TIME: DATE_PICKER_FORMAT_TIME };
